<template>
  <div id="app">
    <!-- 어드민 페이지가 아닐 때만 UI 표시 -->
    <template v-if="!isAdminPage">
      <PopupBanner />
      <FloatingBottomBar />
      <MainHeader />
    </template>

    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script>
import MainHeader from '@/components/web/common/MainHeader.vue'
import FloatingBottomBar from '@/components/web/common/FloatingBottomBar.vue'
import PopupBanner from '@/components/web/common/PopupBanner.vue'

export default {
  name: 'App',
  components: {
    MainHeader,
    FloatingBottomBar,
    PopupBanner
  },
  computed: {
    isAdminPage() {
      return this.$route.path.startsWith('/admin')
    }
  },
  mounted() {
    // 스플래시 제거됨 — 히어로 섹션 즉시 활성화
    window.dispatchEvent(new Event('splash-done'))
  }
}
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/fonts-archive/Paperlogy/subsets/Paperlogy-dynamic-subset.css');
@import url('https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable-dynamic-subset.min.css');
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;1,400;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Great+Vibes&display=swap');

:root {
  /* 폰트 */
  --font-paperlogy: 'Paperlogy', sans-serif;
  --font-pretendard: 'Pretendard Variable', 'Pretendard', sans-serif;
  --font-serif: 'Cormorant Garamond', serif;
  --font-luxury: 'Cinzel', serif;
  --font-script: 'Great Vibes', cursive;

  /* 컬러 - 에코포레 */
  --ecofore-primary: #8cc751;        /* Green */
  --ecofore-primary-light: #a8d678;  /* Light Green */
  --ecofore-primary-dark: #6ba83f;   /* Dark Green */
  --ecofore-accent: #004653;         /* Dark Teal (보조 강조) */
  --summit-black: #101820;          /* Black */
  --summit-dark-gray: #4C4B48;      /* Dark Gray */
  --summit-gray: #707372;           /* Gray */
  --text-color: #101820;
  --white: #ffffff;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: var(--font-pretendard);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-color);
}

.main-content {
  /* padding-top 제거 - 풀스크린 섹션용 */
}

</style>
